<!-- Menu Mobile aside  -->
<div [ngClass]="showMenuMobile ? 'is-active' : ' '" id="container-menu-mobile" class="is-hidden-desktop">
    <aside class="menu mobile">
        <ng-container
                *ngIf="this.deliveryTourService.getDeliveryArea() && this.deliveryTourService.getSelectedDeliveryTour().value">
            <p class="menu-label">
                Liefergebiet
            </p>
            <div class="mb-4">
                <ng-container *ngTemplateOutlet="deliveryInformation"></ng-container>
            </div>
        </ng-container>
        <p class="menu-label">
            Seiten
        </p>
        <ul class="menu-list hidden-start-page">
            <li>
                <a (click)="showMenuMobile = false; selectedGroup = undefined; selectedGroup1 = undefined;"
                   routerLink='/' class="has-text-grey is-block">Startseite</a>
            </li>

        </ul>
        <ul *ngIf="newsAvailable" class="menu-list">
            <li>
                <a (click)="showMenuMobile = false; selectedGroup = undefined; selectedGroup1 = undefined;"
                   routerLink='/news' class="has-text-grey is-block">News</a>
            </li>
        </ul>
        <ul *ngFor="let item of getDynamicPageLinks(['top'])" class="menu-list">
            <li>
                <a *ngIf="(item.externalLinkUrl ?? '').length > 0" href='{{item.externalLinkUrl}}' target="_blank"
                   class="is-block">{{ item.name }}</a>
                <a *ngIf="(item.externalLinkUrl ?? '').length == 0 && item.uniqueName != ''"
                   routerLink='/{{( (item.routerLink?.length ?? 0) > 0) ? item.routerLink : item.uniqueName}}'
                   (click)="showMenuMobile = false; selectedGroup = undefined; selectedGroup1 = undefined;"
                   class="is-block">{{ item.name }}</a>
            </li>

        </ul>
        <p class="menu-label">
            Sortiment
        </p>

        <ul class="menu-list" *ngFor="let group of (global$ | async)?.groups"
            [ngClass]="((selected$ | async)?.group == group.name || (selectedGroup && selectedGroup == group.name)) ? 'is-active' : '' ">
            <li>
                <a (click)="setSelectedGroup(group.name)" class="is-size-6 is-size-5-widescreen "
                   [ngClass]="((selected$ | async)?.group == group.name || (selectedGroup && selectedGroup == group.name)) ? 'is-active' : '' ">{{ group.name }}</a>
                <ul>
                    <li>
                        <a [routerLink]="'/sortiment/' + encodeURIComponent(group.name)"
                           (click)="showMenuMobile = false; selectedGroup1 = undefined;"
                           [ngClass]="(!selectedGroup1 &&  (selected$ | async)?.group == group.name) ? 'is-active' : '' ">Alle
                            Artikel anzeigen</a></li>

                    <li *ngFor="let group1 of group.groups1">
                        <a (click)="navigateToGroup1(group.name, group1.name); showMenuMobile = false; setSelectedGroup1(group1.name)"
                           [ngClass]="((selectedGroup1 && selectedGroup1 == group1.name)) ? 'is-active' : '' ">{{ group1.name }}</a>
                    </li>


                </ul>
            </li>
        </ul>

    </aside>
</div>

<div *ngIf="isWebdrinkUrl()" class="header webdrink">
    <div class="container">
        <div class="logo has-text-left dropdown is-hoverable">
            <div class="dropdown-trigger">
                <img src="https://static.webdrink.de/public/design/logo-lkss.png" alt="Lieber klicken statt schleppen">
            </div>
            <div class="dropdown-menu" id="home-menu" role="menu">
                <div class="dropdown-content">
                    <a href="./" class="dropdown-item">
                        Startseite des Lieferpartners
                    </a>
                    <a href="https://www.webdrink.de/" class="dropdown-item">
                        Zurück zu webDrink.de
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


<div [ngClass]="showMenuMobile ? 'is-mobile-menu' : ''">
    <!-- Template AccountMenu -->
    <ng-template #accountMenu>
        <ng-container>


            <!-- Not logged in -->
            <button *ngIf="!(customer$ | async)" class="dropdown-item is-pointer"
                    (click)="toggleLoginRegister(); showAccountMenuMobile = false">
                Anmelden, Registrieren
            </button>
            <div *ngIf="(customer$ | async)?.id && !(customer$ | async)?.guest" (click)="showAccountMenu=false">
                <a routerLink="/user/data" class="dropdown-item">
                    E-Mail & Benutzer
                </a>
                <a routerLink="/user/password-update" class="dropdown-item">
                    Passwort ändern
                </a>
                <hr class="dropdown-divider">
                <a routerLink="/customer/data" class="dropdown-item">
                    Kundendaten
                </a>
                <a routerLink="/customer/favorites" class="dropdown-item">
                    Favoriten
                </a>
                <a routerLink="/customer/orders" class="dropdown-item">
                    Bestellungen
                </a>
                <a *ngIf="isAccess('invoices')" routerLink="/customer/invoices" class="dropdown-item">
                    Rechnungen
                </a>
                <hr class="dropdown-divider">
                <button class="dropdown-item"
                        *ngIf="(userMappedCustomers$ | async)?.length !== 1 && (userMappedCustomers$ | async)"
                        (click)="deselectCustomer()">
                    <fa-icon [icon]="faUndo"></fa-icon>
                    Kunde wechseln
                </button>
                <hr class="dropdown-divider">
                <button class="dropdown-item"
                        (click)="setLogout(); showAccountMenu = false; showAccountMenuMobile = false;">
                    <fa-icon [icon]="faRightFromBracket"></fa-icon>
                    Abmelden
                </button>
            </div>
            <!-- Guest -->
            <div *ngIf="(customer$ | async)?.guest" (click)="showAccountMenu=false">
                <a class="dropdown-item"
                   (click)="setLogout(); showAccountMenu = false; showAccountMenuMobile = false;">
                    <fa-icon [icon]="faRightFromBracket"></fa-icon>
                    Gastsitzung beenden
                </a>
            </div>
        </ng-container>
    </ng-template>

    <!-- Template DeliveryInformation -->
    <ng-template #deliveryInformation>
        <div>
            <div class="is-inline-block">
                <div class="is-flex  is-align-items-center">
                    <div *ngIf="(this.deliveryTourService.getDeliveryArea() && !deliveryTourService.getSelectedDeliveryTour().value?.pickupTour) || !(customer$ | async)?.id"
                         class="is-flex  is-align-items-center">
                        <div>
                            <fa-icon [icon]="faLocationDot"
                                     class="delivery-location is-size-4"></fa-icon>
                        </div>
                        <div class="pl-2">
                            {{ this.deliveryTourService.getDeliveryArea()?.postcode }} {{ this.deliveryTourService.getDeliveryArea()?.town }}
                        </div>
                    </div>
                    <div *ngIf="!(customer$ | async)?.id">
                        <button (click)="resetDeliveryArea(); showMenuMobile = false;" class="is-pointer ml-2 p-0" pTooltip="Liefergebiet ändern">
                            <fa-icon [icon]="faEdit" role="img" aria-label="Liefergebiet ändern" ></fa-icon>
                        </button>

                    </div>
                </div>
                <button *ngIf="deliveryTourService.getSelectedDeliveryTour().value  && (config$ | async)?.orderDeliveryDateSelectable"
                        (click)="op.toggle($event)"
                        class="is-pointer is-size-6 p-0">
                    <fa-icon [icon]="faTruck" class="ml-1"></fa-icon>
                    <span *ngIf="(deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDates?.length ?? 0) > 0"
                          class="ml-2">{{ deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDates }}</span>
                    <span *ngIf="(deliveryTourService.getSelectedDeliveryTour().value?.nameDeliveryDates?.length ?? 0) == 0"
                          class="ml-2">Liefertage</span>
                </button>
                <p-popover #op>
                    <ng-template pTemplate="content">
                        <iw-shop-delivery-tour-next-delivery-date></iw-shop-delivery-tour-next-delivery-date>
                    </ng-template>
                </p-popover>
            </div>
        </div>
    </ng-template>

    <header>
        <div class="container-top header menu groups">


            <div [formGroup]="form">
                <!-- Container Header -->
                <div class="container-header">
                    <div class="container is-fullhd">
                        <div class="is-flex is-align-items-center py-2-desktop py-0-touch">
                            <div class="mr-4">
                                <a routerLink="/"> <img
                                        src="{{resourceUrl}}{{(config$ | async)?.dealer?.relativeLogoPath}}"
                                        alt="{{resourceUrl}}{{(config$ | async)?.dealer?.company}}"
                                        class="logo"></a>
                            </div>


                            <div class=" pr-6-desktop container-search"
                                 [ngClass]="(!this.deliveryTourService.getDeliveryArea() || !this.deliveryTourService.getSelectedDeliveryTour().value) ? 'is-flex-grow-1' : ''">
                                <div class="field">
                                    <form autocomplete="off">
                                        <p class="control  has-icons-right">
                                            <input id="searchString" class="input search" formControlName="searchString"
                                                   (keyup.enter)="$event.preventDefault()"
                                                   autocomplete="new-password"
                                                   type="text"
                                                   placeholder="Wonach suchen Sie?">
                                            <span class="icon is-small is-right">
                                    <a class="search-submit"><fa-icon [icon]="faSearch"></fa-icon></a>
                                </span>
                                        </p>
                                    </form>

                                </div>
                            </div>
                            <div *ngIf="this.deliveryTourService.getSelectedDeliveryTour().value"
                                 class="is-hidden-touch is-flex-grow-1 delivery-information">
                                <ng-container *ngTemplateOutlet="deliveryInformation"></ng-container>
                            </div>

                            <div class="is-hidden-touch mt-2 is-flex">
                                <div *ngIf="newsAvailable" class="container-item">
                                    <a routerLink="/news" class="item has-text-centered is-size-7 is-block">
                                        <fa-icon [icon]="faEnvelope" class="is-size-6"></fa-icon>
                                        <span class="is-block">News</span>
                                        <button *ngIf="newsUnreadCounter > 0"
                                                class="button news-counter is-small is-rounded px-2 py-0 mt-1">
                                            {{ newsUnreadCounter }}
                                        </button>
                                    </a>
                                </div>
                                <div class="container-item pl-5" (clickOutside)="showAccountMenu = false">
                                    <div class="dropdown" [ngClass]="showAccountMenu ? 'is-active' : ''">
                                        <button class="dropdown-trigger item"
                                                aria-haspopup="true"
                                                [attr.aria-expanded]="showAccountMenu"
                                                (click)="showAccountMenu = !showAccountMenu"
                                                (keydown.escape)="showAccountMenu = false"
                                                type="button">
                                            <fa-icon [icon]="faUser" class="is-size-6"
                                                     aria-hidden="true"></fa-icon>
                                            <p class="is-size-7">{{ myAccount }}</p>
                                        </button>
                                        <div class="dropdown-menu has-text-left" *ngIf="showAccountMenu">
                                            <div class="dropdown-content" role="menu">
                                                <ng-container *ngTemplateOutlet="accountMenu"></ng-container>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div routerLink="/customer/favorites" class="container-item pl-5">
                                    <a class="item is-size-7 is-block">
                                        <fa-icon [icon]="faHeart" role="img" aria-label="Favoriten"
                                                 class="is-size-6"></fa-icon>
                                        <br>
                                        Favoriten
                                    </a>
                                </div>

                                <div class="container-item pl-5">
                                    <a routerLink="/cart" class="item has-text-centered is-size-7 is-block">
                                        <fa-icon [icon]="faShoppingBag" role="img"
                                                 aria-label="Warenkorb" class="is-size-6"></fa-icon>
                                        <br>
                                        <span>Warenkorb</span>
                                        <button *ngIf="articlesInCart"
                                                class="button cart-counter is-small is-rounded px-2 py-0 mt-1">
                                            {{ articlesInCart }}
                                        </button>
                                    </a>
                                </div>
                            </div>
                            <div class="is-hidden-desktop has-text-right">
                                <a class="is-inline-block is-size-2 has-text-white">
                                    <div class="item burger ">
                                        <button (click)="toggleMenuMobile()" class="hamburger" type="button" aria-label="Menu">
                                      <span class="hamburger-box hamburger--elastic "
                                            [ngClass]="showMenuMobile ? 'is-active' : ''">
                                        <span class="hamburger-inner"></span>
                                      </span>
                                        </button>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           <!-- Container Menu -->
            <div *ngIf="(getDynamicPageLinks(['top'])?.length ?? 0) > 0" id="container-menu-pages"
                 class="container-menu-background pages is-hidden-touch">
                <!-- Menu Desktop -->
                <div class="container is-fullhd">
                    <div class="container-menu pages">
                        <ng-container *ngFor="let item of getDynamicPageLinks(['top'])">
                            <div class="container-item page-{{ sanitizeUniqueName(item.uniqueName) }}">
                                <a *ngIf="(item.externalLinkUrl ?? '').length > 0" href='{{item.externalLinkUrl}}'
                                   target="_blank"
                                >{{ item.name }}</a>
                                <a *ngIf="(item.externalLinkUrl ?? '').length == 0"
                                   routerLink='/{{( (item.routerLink?.length ?? 0) > 0) ? item.routerLink : item.uniqueName}}'
                                >{{ item.name }}</a>
                            </div>

                        </ng-container>

                    </div>
                </div>
            </div>
            <!-- Container Article Groups -->
            <div id="container-menu-article-groups" class="container-menu-background article-groups">
                <!-- Menu Desktop -->
                <div id="container-menu-article-groups-desktop" class="container is-fullhd is-hidden-touch">
                    <div class="container-menu is-desktop py-2">
                        <div *ngFor="let group of (global$ | async)?.groups" class="container-item mr-1"><a
                                [routerLink]="'/sortiment/' + encodeURIComponent(group.name)"
                                [ngClass]="((global$ | async)?.selected?.group == group.name) ? 'is-active' : ''">{{ group.name }}</a>
                        </div>
                    </div>
                </div>
                <!-- Menu Mobile Bottom  -->
                <div class="container p-0 is-hidden-desktop">
                    <div class="container-menu is-flex">
                        <div class="container-item is-flex-grow-1">
                            <a routerLink="/customer/favorites" class="item is-size-7 is-block">
                                <fa-icon  [icon]="faHeart" role="img" aria-label="Favoriten"
                                         class="is-size-5"></fa-icon>
                                <br>
                            </a>
                        </div>
                        <div class="container-item is-flex-grow-1" (clickOutside)="showAccountMenuMobile = false">
                            <div class="dropdown is-up is-block" [ngClass]="showAccountMenuMobile ? 'is-active' : ''">
                                <a class="dropdown-trigger item is-size-7"
                                   (click)="showAccountMenuMobile = !showAccountMenuMobile">
                                    <fa-icon  [icon]="faUser" role="img" aria-label="Mein Account"
                                             class="is-size-5"></fa-icon>
                                    <br>
                                </a>
                                <div class="dropdown-menu has-text-left">
                                    <div class="dropdown-content">
                                        <ng-container *ngTemplateOutlet="accountMenu"></ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container-item is-flex-grow-1 is-relative">
                            <a routerLink="/cart" aria-label="Warenkorb" class="item has-text-centered is-size-7 is-block">
                                <fa-icon  [icon]="faShoppingBag" class="is-size-5"></fa-icon>
                                <br>
                                <button *ngIf="articlesInCart"
                                        class="button cart-counter is-small is-rounded px-2 py-0">
                                    {{ articlesInCart }}
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- MenuSub Desktop -->
            <!--    <div class="container-menu-background sub has-background-white">

                    <div class="container container-menu is-flex is-hidden-touch is-flex-wrap-wrap has-background-white">
                        <div *ngFor="let group of (global$ | async)?.groups" class="container-item sub"><a
                                [routerLink]="'/sortiment/' + encodeURIComponent(group.name)"  [ngClass]="((global$ | async)?.selected?.group == group.name) ? 'is-active' : ''">{{group.name}}</a></div>
                    </div>
                </div>-->
        </div>
        @if (notification) {
            <div class="container is-fullhd mt-4">
            <article class="message has-background-white">
                <div class="message-body" [innerHTML]="notification">
                </div>
            </article>
        </div>
        }

        <!-- Breadcrumb -->
        <div *ngIf="(breadcrumb | async)?.level1?.name" class="container is-fullhd mt-5-desktop mt-2-mobile mb-4 mt-4">
            <nav class="breadcrumb mb-0-touch " aria-label="breadcrumbs">
                <ul>
                    <li class="level-0">
                        <a routerLink="/">
                      <span class="icon is-small">
                          <fa-icon [icon]="faHome"></fa-icon>
                      </span>
                            <span>Home</span>
                            <span class="is-hidden-desktop mx-2"> | </span>
                        </a>
                    </li>
                    <li [class]="!(breadcrumb | async)?.level2?.name ? 'is-active level-1' : 'level-1'">

                        <h1 *ngIf="!(breadcrumb | async)?.level1?.routerLink" class="pt-2-desktop pl-1">
                            <span>{{ (breadcrumb | async)?.level1?.name }}</span>
                        </h1>
                        <a *ngIf="(breadcrumb | async)?.level1?.routerLink"
                           [routerLink]="(breadcrumb | async)?.level1?.routerLink"
                           [queryParams]="(breadcrumb | async)?.level1?.routerQueryParams"
                           [fragment]="(breadcrumb | async)?.level1?.routerFragment ?? ''">
                            <span> {{ (breadcrumb | async)?.level1?.name }}</span>
                        </a>
                    </li>
                    <li *ngIf="(breadcrumb | async)?.level2?.name" class="is-active level-2">
                        <a href="#">
                            <span>{{ (breadcrumb | async)?.level2?.name }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </header>

    <!-- Content -->
    <main>
        <div class="container-content">
            <ng-content></ng-content>
        </div>
    </main>

    <footer>
        <!-- Foot -->
        <div class="container-foot mt-6-desktop mt-4">
            <div class="container">
                <div class="columns">

                    <div class="column">
                        <img src="{{resourceUrl}}{{(config$ | async)?.dealer?.relativeLogoPath}}"
                             alt="{{resourceUrl}}{{(config$ | async)?.dealer?.company}}}" class="logo">
                    </div>
                    <div class="column">
                        <div *ngIf="(config$ | async)?.paymentMethods?.stripe || (config$ | async)?.paymentMethods?.klarna || ((config$ | async)?.paymentMethods?.dynamic?.length ?? 0) > 0"
                             class="container-payments mx-4 has-background-white pb-4 pl-4 pr-4 pt-1 p-4-touch mx-0-touch ">
                            <p class="has-text-weight-bold mb-2">Zahlungsmöglichkeiten</p>
                            <div *ngIf="(config$ | async)?.paymentMethods?.paypal">
                                <p *ngIf="!(config$ | async)?.paymentMethods?.paypal?.image">{{ (config$ | async)?.paymentMethods?.paypal?.name }}</p>
                                <img *ngIf="(config$ | async)?.paymentMethods?.paypal?.image"
                                     src="{{resourceUrl}}{{(config$ | async)?.paymentMethods?.paypal?.image}}"
                                     alt="PayPal"/>
                            </div>
                            <div *ngIf="(config$ | async)?.paymentMethods?.stripe">
                                <p *ngIf="!(config$ | async)?.paymentMethods?.stripe?.image">{{ (config$ | async)?.paymentMethods?.stripe?.name }}</p>
                                <img *ngIf="(config$ | async)?.paymentMethods?.stripe?.image"
                                     src="{{resourceUrl}}{{(config$ | async)?.paymentMethods?.stripe?.image}}"
                                     alt="Stripe"/>
                            </div>
                            <div *ngIf="(config$ | async)?.paymentMethods?.klarna">
                                <p *ngIf="!(config$ | async)?.paymentMethods?.klarna?.image">{{ (config$ | async)?.paymentMethods?.klarna?.name }}</p>
                                <img *ngIf="(config$ | async)?.paymentMethods?.klarna?.image"
                                     src="{{resourceUrl}}{{(config$ | async)?.paymentMethods?.klarna?.image}}"
                                     alt="Klarna"/>
                            </div>
                            <div *ngFor="let p of (config$ | async)?.paymentMethods?.dynamic">
                                <p *ngIf="!p.image">{{ p.name }}</p>
                                <img *ngIf="p.image" src="{{resourceUrl}}{{p.image}}" alt="{{p.name}}"/>
                            </div>
                        </div>


                    </div>
                    <div class="column">
                        <ng-container *ngFor="let item of getDynamicPageLinks(['foot_0'])">
                            <a *ngIf="(item.externalLinkUrl ?? '').length > 0" href='{{item.externalLinkUrl}}'
                               target="_blank"
                               class="is-block">{{ item.name }}</a>
                            <a *ngIf="(item.externalLinkUrl ?? '').length == 0"
                               routerLink='/{{( (item.routerLink?.length ?? 0) > 0) ? item.routerLink : item.uniqueName}}'
                               class="is-block">{{ item.name }}</a>
                        </ng-container>
                    </div>
                    <div class="column">
                        <ng-container *ngFor="let item of getDynamicPageLinks(['foot_1'])">
                            <a *ngIf="(item.externalLinkUrl ?? '').length > 0" href='{{item.externalLinkUrl}}'
                               target="_blank"
                               class="is-block">{{ item.name }}</a>
                            <a *ngIf="(item.externalLinkUrl ?? '').length == 0"
                               routerLink='/{{( (item.routerLink?.length ?? 0) > 0) ? item.routerLink : item.uniqueName}}'
                               class="is-block">{{ item.name }}</a>
                        </ng-container>
                        <button class="withdrawel-button button is-fullwidth is-block is-secondary mt-2 mb-2 is-uppercase" [ngClass]="isWithdrawalEnabled ? '' : 'is-invisible'" routerLink="/vertrag-widerrufen">Vertrag widerrufen</button>

                    </div>
                    <div class="column">

                        <ng-container *ngFor="let item of getDynamicPageLinks(['foot_2'])">
                            <a *ngIf="(item.externalLinkUrl ?? '').length > 0" href='{{item.externalLinkUrl}}'
                               target="_blank"
                               class="is-block">{{ item.name }}</a>
                            <a *ngIf="(item.externalLinkUrl ?? '').length == 0"
                               routerLink='/{{( (item.routerLink?.length ?? 0) > 0) ? item.routerLink : item.uniqueName}}'
                               class="is-block">{{ item.name }}</a>
                        </ng-container>

                    </div>
                </div>


            </div>
            <div *ngIf="isWebdrinkUrl()" class="container webdrink">
                <div class="columns">
                    <div class="column">
                        <p class="title">webDrink.de</p>
                        <p class="subtitle">Lieber klicken statt schleppen</p>
                    </div>
                    <div class="column has-text-right">
                    </div>
                </div>
                <hr>
                <div class="has-text-right-desktop">
                    <a href="https://www.webdrink.de/gfgh.html" target="_blank" rel="nofollow" class="link">Teilnahme
                        für Getränkehändler</a>
                    <a href="https://www.webdrink.de/barrierefreiheit.html" rel="nofollow" target="_blank" class="link">Barrierefreiheit</a>
                    <a href="https://www.webdrink.de/anb.html" target="_blank" rel="nofollow" class="link">Allgemeine
                        Nutzungsbedingungen</a>
                    <a href="https://www.webdrink.de/datenschutz.html" rel="nofollow" target="_blank" class="link">Datenschutzerklärung</a>
                </div>
            </div>
            <div class="container-iw is-flex is-align-items-end is-justify-content-end">
                <a href="https://www.indenware.de" target="_blank" class="is-size-7 mx-1">
                    <img src="/assets/design/iw-logo-white.svg" alt="IndenWare GmbH"/>
                </a>
                <p class="txt pb-1">Shopsystem v20260831</p>
            </div>
        </div>
    </footer>

</div>



